export default __webpack_public_path__ + "static/media/text1INFO.8e64534e.glb";